<template>
  <b-form @submit="onSubmit" autocomplete="off" class="form-horizontal">
    <!-- Page title -->
    <b-row>
      <b-col md="12">
        <h3 class="text-themecolor">
         {{$t('carpetline.portalgebruiker')}} <span v-if="command.id">{{$t('klantrelaties.bewerker')}}</span><span v-else>{{$t('klantrelaties.aanmaker')}}</span>
        </h3>
      </b-col>
    </b-row>
    <!-- Page title -->

    <!-- Form content -->
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <!-- firstName -->
            <b-form-group label-cols :label="$t('datatables.voornaam')">
              <b-form-input v-model="command.firstName" type="text" :placeholder="$t('datatables.voornaam')"/>
              <validation element="first_name"/>
            </b-form-group>
            <!-- lastName -->
            <b-form-group label-cols :label="$t('datatables.achternaam')">
              <b-form-input v-model="command.lastName" type="text" :placeholder="$t('datatables.achternaam')"/>
              <validation element="last_name"/>
            </b-form-group>
            <!-- emailAddress -->
            <b-form-group label-cols :label="$t('datatables.emailadres')">
              <b-form-input v-model="command.emailAddress" type="text" :placeholder="$t('datatables.emailadres')"/>
              <validation element="email_address"/>
            </b-form-group>
            <!-- password -->
            <b-form-group label-cols :label="$t('wachtwoord.wachtwoord')">
              <b-input-group>
                <b-form-input v-model="command.password" type="password" :placeholder="$t('wachtwoord.wachtwoord')"
                              v-on:keyup.native="checkPassword(command.password)"
                              v-on:keydown.native="clearGeneratedPassword"/>
                <b-input-group-append>
                  <b-input-group-text slot="append">
                    <font-awesome-icon v-if="hasPassError" class="text-danger" id="passwordInfo"
                                       icon="question-circle"/>
                    <font-awesome-icon v-else id="passwordInfo" class="text-success" icon="question-circle"/>
                    <b-tooltip target="passwordInfo">
                      <span>{{$t('wachtwoord.hetwachtwoordmoetbestaanuit')}}:</span>
                      <ul style="list-style: none; padding: 0">
                        <li v-if="hasNumber" class="text-success">
                          <font-awesome-icon icon="check"/>
                          {{$t('wachtwoord.eencijfer')}}
                        </li>
                        <li v-else class="text-danger">
                          <font-awesome-icon icon="times"/>
                          {{$t('wachtwoord.eencijfer')}}
                        </li>
                        <li v-if="hasLetter" class="text-success">
                          <font-awesome-icon icon="check"/>
                          {{$t('wachtwoord.eenkleineletter')}}
                        </li>
                        <li v-else class="text-danger">
                          <font-awesome-icon icon="times"/>
                          {{$t('wachtwoord.eenkleineletter')}}
                        </li>
                        <li v-if="hasCapital" class="text-success">
                          <font-awesome-icon icon="check"/>
                          {{$t('wachtwoord.eenhoofdletter')}}
                        </li>
                        <li v-else class="text-danger">
                          <font-awesome-icon icon="times"/>
                          {{$t('wachtwoord.eenhoofdletter')}}
                        </li>
                        <li v-if="passLength" class="text-success">
                          <font-awesome-icon icon="check"/>
                          {{$t('wachtwoord.minimaal8karakters')}}
                        </li>
                        <li v-else class="text-danger">
                          <font-awesome-icon icon="times"/>
                          {{$t('wachtwoord.minimaal8karakters')}}
                        </li>
                      </ul>
                    </b-tooltip>
                  </b-input-group-text>
                  <b-btn class="waves-effect waves-dark" v-on:click="generatePassword" variant="primary">{{$t('wachtwoord.genereer')}}
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
              <validation element="password"/>
            </b-form-group>
            <!-- confirm password -->
            <b-form-group label-cols :label="$t('wachtwoord.wachtwoordbevestigen')">
              <b-input-group>
                <b-form-input v-model="command.confirmPassword" type="password" :placeholder="$t('wachtwoord.wachtwoordbevestigen')"
                              v-on:keydown.native="clearGeneratedPassword"/>
              </b-input-group>
              <validation element="confirm_password"/>
            </b-form-group>
            <b-form-group v-if="isGenerated" horizontal :label="$t('wachtwoord.gegenereerdwachtwoord')">
              <span>{{generatedPassword}}</span>
            </b-form-group>
            <!-- customerRelationId -->
            <b-form-group label-cols :label="$t('datatables.relatie')">
              <selectize ref="customerRelation" v-model="command.customerRelationId" :settings="selectizeSettings"
                         :placeholder="$t('wachtwoord.zoeken')"/>
            </b-form-group>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Form content -->

    <!-- Submit controls -->
    <b-row>
      <b-col md="12">
        <b-button @click="goTo(command.id ? 'detail' : 'index')" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
        <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
      </b-col>
    </b-row>
    <!-- Submit controls -->
  </b-form>
</template>
<script>

//Import command
import Command from './command'

export default {
    data () {
        var vm = this;
        return {
          isGenerated: false,
          generatedPassword: '',
          hasNumber: false,
          hasLetter: false,
          hasCapital: false,
          passLength: false,
          hasPassError: true,
          command: new Command(),
          customerRelationId: '',
          customerRelations: [],
          settingsMultiOption: { maxItems: 10 },
          password: this.value,
          selectizeSettings: {
            valueField: 'id',
            labelField: 'name',
            searchField: ['name', 'tag'],
            options: {},
            create: false,
            render:
            {
                option: function(item, escape) {
                    return '<div><strong>#' + escape(item.tag) + '&nbsp;' + escape(item.name) + '</strong><br/>' +
                        '<small class="text-muted">'+(item.address ? escape(item.address.fullAddress) : '')+'</small></div>';
                }
            },
            load: function (query, callback) {
                //Check if query has length
                if (!query.length) return callback();

                vm.$store.dispatch('core/search',`customer-relations?query=${query}`)
                .then((customerRelations) => {
                    callback(customerRelations);
                })
                .catch(() => {
                    callback();
                })
            },
          },
        }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();
          const vm = this;
          vm.command.modules = ['carpetline']
          let payload = {
            resource: 'users',
            params: vm.command
          };
          vm.$store.dispatch('core/create',payload)
          .then((data) => 
            vm.$store.dispatch('carpetline/create',
            {
              resource: 'user-customer-relations',
              params: { 
                userId: data.id,
                customerRelationId: vm.command.customerRelationId,
                password: vm.command.password,
                emailAddress: vm.command.emailAddress,
                firstName: vm.command.firstName,
                lastName: vm.command.lastName
              }
            })
            .then(() => {
                vm.goTo('index');
            })
          );
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `user-customer-relations:${name}` });
        },
      CheckNormalLetter(password) {
        let letterRexEx = RegExp("[a-z]");
        this.hasLetter = letterRexEx.test(password);

        return this.hasLetter;
      },
      CheckCapitalLetter(password) {
        let CapitalRegEx = RegExp("[A-Z]");
        this.hasCapital = CapitalRegEx.test(password);

        return this.hasCapital;
      },
      CheckNumber(password) {
        let numberRegEx = RegExp("[0-9]");
        this.hasNumber = numberRegEx.test(password);

        return this.hasNumber;
      },
      generatePassword() {
        let generatedPassword = "";
        let charSet = "abcdefghijklmnopqrstuvwxyz";
        charSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        charSet += "0123456789";
        // charSet += "![]{}()%&*$#^<>~@|";
        let passwordLength = 15;
        do {
          generatedPassword = "";
          for (let i = 0; i < passwordLength; i++) {
            generatedPassword += charSet.charAt(Math.floor(Math.random() * charSet.length));
          }
        }
        while (this.checkPassword(generatedPassword));
        this.isGenerated = true;
        this.generatedPassword = generatedPassword;
        this.command.confirmPassword = generatedPassword;
        this.command.password = generatedPassword;
      },
      checkPassword: function (password) {
        if (password === "") {
          this.passLength = false;
          this.hasLetter = false;
          this.hasCapital = false;
          this.hasNumber = false;
          this.hasPassError = true;

          return false;
        }
        this.passLength = password.length >= 8;
        this.CheckCapitalLetter(password);
        this.CheckNormalLetter(password);
        this.CheckNumber(password);
        this.hasPassError = !(this.hasNumber && this.hasCapital && this.hasLetter && this.passLength);

        return this.hasPassError;
      },
      clearGeneratedPassword: function () {
        this.generatedPassword = "";
        this.isGenerated = false;
      }
    }
}
</script>
